<template>
  <div :class="jel_getClassObject(content)">
    <span class="lienPrimaire cursor-pointer" @click="isAfficherModale = true">
      {{ content.libBouton }}
    </span>
    <b-modal
      v-model="isAfficherModale"
      :hide-footer="true"
      dialog-class="d-flex align-items-center h-100"
      body-class="compteClair pt-0"
    >
      <template #modal-header>
        <div class="float-right icone-fermer" @click="isAfficherModale = false">
          <svg-icon
            icon-name="icone-fermer-mince"
            color="$couleur-primaire"
            className="iconeFermer"
          />
        </div>
      </template>
      <div class="configuration">
        <div class="info">{{ $t('messageComponent.navigateur') }}</div>
        <div class="resultat p-0">{{ browser }} {{ browserVersion }}</div>
      </div>
      <div class="configuration">
        <div class="info">{{ $t('messageComponent.langue') }}</div>
        <div class="resultat p-0">{{ navigator.language }}</div>
      </div>
      <div class="configuration">
        <div class="info">{{ $t('messageComponent.cookie') }}</div>
        <div class="resultat p-0">
          {{
            navigator.cookieEnabled
              ? $i18n.tc('messageComponent.oui')
              : $i18n.tc('messageComponent.non')
          }}
        </div>
      </div>
      <div class="configuration">
        <div class="info">{{ $t('messageComponent.systeme') }}</div>
        <div class="resultat p-0">{{ navigator.platform }}</div>
      </div>
      <div class="configuration">
        <div class="info">{{ $t('messageComponent.infoTechnique') }}</div>
        <div class="resultat p-0">{{ navigator.userAgent }}</div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { browser, browserVersion } from '@/helpers/UserAgentHelpers';

import SvgIcon from '../../helpers/SvgIcon.vue';

export default {
  name: 'ConfigurationOrdinateur',
  components: { SvgIcon },
  props: { content: { type: Object, required: true } },
  data() {
    return {
      isAfficherModale: false,
    };
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          cookie: 'Cookie Activé?',
          infoTechnique: 'Information technique',
          langue: 'Langue du navigateur',
          navigateur: 'Navigateur',
          non: 'Non',
          oui: 'Oui',
          systeme: `Système d'exploitation`,
        },
      },
      en: {
        messageComponent: {
          cookie: 'Activated Cookies?',
          infoTechnique: 'Technical info',
          langue: 'Browser language',
          navigateur: 'Browser',
          non: 'No',
          oui: 'Yes',
          systeme: 'Operating system',
        },
      },
    },
  },
  computed: {
    navigator() {
      return navigator;
    },
    browser() {
      return browser();
    },
    browserVersion() {
      return browserVersion(browser());
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.icone-fermer,
.lienSecondaire {
  &:hover {
    cursor: pointer;
  }
}
.configuration {
  display: flex;
  padding: 4px;
  padding-bottom: 4px;
  &:nth-child(2n - 1) {
    background-color: #eeeeee;
  }
  .info {
    font-weight: 700;
    padding-left: 4px;
    flex: 0 0 33%;
    max-width: 33%;
  }
  .resultat {
    flex: 0 0 67%;
    max-width: 67%;
  }
}
</style>
